import { useNavigate } from "react-router-dom";

import { useReceivableDetail } from "../../hooks/useReceivableDetail";
import { useSale } from "../../../../../hooks/sale/useSale";
import { useReceivablePdf } from "../../../../../hooks/pdf/useReceivablePdf";

import { detailActions } from "../../config/detailActions.config";

const DetailActionsSection = () => {
  const navigate = useNavigate();

  const { detail } = useReceivableDetail();
  const { handlerViewSaleById } = useSale();
  const { handleDownloadReceivablePdf } = useReceivablePdf();

  const handleViewSaleOrigin = () => {
    if (detail?.origin?.saleId) {
      handlerViewSaleById(detail.origin.saleId);
    }
  };

  const handleRegisterPayment = () => {
    if (!detail) return;

    navigate(`/finance/cxc/register-payment/${detail.id}`);
  };

  const handleAccountStatement = () => {
    if (!detail) return;

    handleDownloadReceivablePdf(detail.id);
  };

  const handleSendReminder = () => {
    console.log("Enviar recordatorio");
  };

  const handleActionClick = (actionKey: string) => {
    if (!detail) return;

    switch (actionKey) {
      case "view-sale-origin":
        handleViewSaleOrigin();
        break;

      case "register-payment":
        handleRegisterPayment();
        break;

      case "account-status":
        handleAccountStatement();
        break;

      case "send-reminder":
        handleSendReminder();
        break;

      default:
        break;
    }
  };

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Acciones rápidas
      </h4>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {detailActions.map((action) => {
          const Icon = action.icon;

          return (
            <button
              key={action.key}
              type="button"
              onClick={() => handleActionClick(action.key)}
              className={`
                group
                flex flex-col items-center justify-center
                gap-3
                rounded-xl
                border
                px-5
                py-4
                text-center
                font-medium
                transition-all
                duration-200
                hover:shadow-sm
                ${action.variant}
                ${action.featured ? "scale-[1.01]" : ""}
              `}
            >
              <div
                className="
                  flex h-11 w-11 items-center justify-center
                  rounded-full
                  bg-white
                  shadow-sm
                  dark:bg-boxdark-2
                "
              >
                <Icon size={21} />
              </div>

              <span className="text-sm font-semibold leading-tight">
                {action.title}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default DetailActionsSection;